import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { UseMutationOptions, useMutation } from 'react-query'

type Props = {
  almanacFileKey: string
}

type Data = { success: boolean; design: any }

type Options = Omit<UseMutationOptions<Data, unknown, void>, 'mutationKey' | 'mutationFn'>

const removeAudio = async (workspaceId: number, almanacFileKey: string) => {
  const res = await sendToApi(`/w/${workspaceId}/designs/${almanacFileKey}/remove_audio`, {
    method: 'POST',
  })

  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }

  return res.data
}

export const useRemoveDesignAudio = ({ almanacFileKey }: Props, options?: Options) => {
  const workspaceId = useCurrentWorkspaceId()
  return useMutation<Data, Error, void>(() => removeAudio(workspaceId, almanacFileKey), options)
}
